<p-dialog [header]="alertContent.header" [modal]="true" [(visible)]="visible"   styleClass="modal-sm">
    <p>
        {{alertContent.message}}
    </p> 
</p-dialog>
